import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65647de2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "productDescriptionEntry" };
const _hoisted_2 = { class: "productDescriptionEntry-Header px-0 py-4" };
const _hoisted_3 = { class: "font6-responsive text-left" };
const _hoisted_4 = { class: "fade-in productDescriptionEntry-Content font6-responsive pb-4 text-left" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "trustpilot-widget",
    "data-locale": "de-DE",
    "data-template-id": "54ad5defc6454f065c28af8b",
    "data-businessunit-id": "5de8f7e831cfbb00014033b8",
    "data-style-height": "240px",
    "data-style-width": "100%",
    "data-theme": "light",
    "data-tags": "BLAU-Website",
    "data-stars": "4,5",
    "data-review-languages": "de"
}, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://de.trustpilot.com/review/myswooop.de",
        target: "_blank",
        rel: "noopener"
    }, "Trustpilot")
], -1));
const _hoisted_6 = [
    _hoisted_5
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, [
                _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleExpansion())),
                    title: "Bewertungen",
                    class: "pl-0 pr-1 d-flex justify-content-between align-items-start strong pointerhover fc-brand_deep_blue",
                    role: "button"
                }, [
                    _createTextVNode(" Bewertungen "),
                    _createElementVNode("i", {
                        class: _normalizeClass([{ 'icon-brand_plus': !_ctx.expanded, 'icon-brand_minus': _ctx.expanded }, "float-right ml-4 fc-brand_green_hover"])
                    }, null, 2)
                ])
            ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
            [_vShow, _ctx.expanded]
        ])
    ]));
}
